import * as api from './api';
import * as types from './mutations';

const state = {
    isProcessing: false,
    assessments: {},
};

const getters = {

};

const actions = {
    getAssessment({commit, state}, {courseHashedId}) {
        return new Promise((resolve, reject) => {
            if (state.assessments[courseHashedId]) {
                return resolve(state.assessments[courseHashedId]);
            }

            commit(types.SET_PROCESSING_STATE, true);
            axios.get(api.getAssessment(courseHashedId))
                .then(({data}) => {
                    commit(types.UPDATE_ASSESSMENT_ANSWERS, {courseHashedId, data: data.memberAssessment.data});
                    resolve(data.memberAssessment.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    saveAnswer({commit, state}, {courseHashedId, memberAssessmentId, order, answer}) {
        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);
            axios.patch(api.saveAnswer(memberAssessmentId), {order, answer})
                .then(({data}) => {
                    commit(types.UPDATE_ASSESSMENT_ANSWERS, {courseHashedId, data: data.memberAssessment.data});
                    resolve(data.memberAssessment.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    submit({commit, state}, {courseHashedId, memberAssessmentId, answers}) {
        return new Promise((resolve, reject) => {
            commit(types.SET_PROCESSING_STATE, true);

            axios.patch(api.submit(memberAssessmentId), {answers})
                .then(({data}) => {
                    commit(types.UPDATE_ASSESSMENT_ANSWERS, {courseHashedId, data: data.memberAssessment.data});
                    resolve(data.memberAssessment.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
};

const mutations = {
    [types.UPDATE_ASSESSMENT_ANSWERS](state, {courseHashedId, data}) {
        state.assessments = {...state.assessments, [courseHashedId]: data};
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};